import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CenterVh = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
  height: "100vh",
});
